export default "__VITE_ASSET__xiMK3U28__"